import { useUserContext } from 'src/providers/UserProvider/User.context';
import { eUserRole } from 'src/providers/UserProvider/User.enums';

/**
 * Único lugar que decide quién puede recargar el saldo (RET-2115; SSOT v1.73,
 * DS-03 §3: "solo Owner y Admin recargan").
 *
 * Antes de este hook la regla estaba escrita cuatro veces, de tres formas
 * distintas, una por punto de montaje (BalanceTab, SubscriptionBalanceSection,
 * Template, WabTemplatesVariablesAction) — y en dos superficies que también
 * ofrecen recargar (la propia tarjeta de saldo, WhatsApp API → General) no
 * estaba escrita en absoluto: un Seller veía el botón de recargar y el switch
 * de recarga automática, y el BFF le negaba la compra con 403 (RET-1843).
 * `Wallet.topUpRoleGate.contract.test.ts` vigila por grep, en cada corrida,
 * que ningún módulo del dominio vuelva a derivarla aparte.
 *
 * Vive en el slice del wallet y no en `ACLProvider` por el mismo motivo que
 * `useWalletFlag`: ese contexto lo consume media app, y colgar aquí una
 * lectura más ensancha el radio de re-render de todo lo que ya lo consume. El
 * wallet lee `UserContext` directo y deriva su propia respuesta, tal como
 * `useWalletFlag` deriva la suya de `FeatureFlagsContext` en vez de sumarse al
 * `useMemo` de ese provider.
 *
 * Lista BLANCA (Owner/Admin), no lista negra (≠ Seller). Antes de este fix la
 * tarjeta de Suscripción usaba la negra y dejaba pasar al Viewer, mientras el
 * resto de las superficies usaba la blanca — dos respuestas para el mismo
 * rol. La regla citada por el ticket y por el SSOT es la blanca, así que aquí
 * el Viewer queda fuera igual que el Seller (cambio de conducta deliberado en
 * Suscripción; ver el registro de riesgo de RET-2115).
 */
export function useTopUpRoleGate() {
  const { currentUserRole } = useUserContext();

  const canTopUp =
    currentUserRole === eUserRole.OWNER || currentUserRole === eUserRole.ADMIN;

  return { canTopUp };
}
